/* istanbul ignore file */
import React from 'react';
import { useShowContext } from 'framework/show';
import { SingleBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import AccountsBreadcrumbs from 'domain/sales/account/shared/AccountsBreadcrumbs';
import { useAccountUrl } from 'domain/shared/account';

const SingleAccountBreadcrumbs = ({ children = null }: { children?: React.ReactNode }) => {
  const { data } = useShowContext();
  const { getSingleEntityUrl } = useAccountUrl();
  const accountName = data.getValueBySource('accountName');
  const id = data.getValueBySource('accountId');
  const singleAccountUrl = getSingleEntityUrl(id);

  return (
    <AccountsBreadcrumbs>
      <SingleBreadcrumbItem entity={accountName || id} link={singleAccountUrl} />
      {children}
    </AccountsBreadcrumbs>
  );
};

export default SingleAccountBreadcrumbs;
